<template>
  <div>
    <section>
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.vendor')"/>
        <div class="form-row mb-2">
          <div class="col-12">
            <label>{{ $t('message.storecompanyperson') }}</label>
            <select
              :disabled="true"
              class="form-control form-control-sm custom-select">
              <option v-if="po.vendor">{{ po.vendor.vendor_name }}</option>
            </select>
          </div>
        </div>
        <div class="form-row mb-2">
          <div class="col-6">
            <div class="form-group row mb-1">
              <div class="col-md-12">
                <label>{{ $t('message.address') }}</label>
                <textarea
                  :disabled="true"
                  class="form-control"
                  style="height: 91px;">{{ po.vendor.address }}</textarea>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row mb-1">
              <div class="col-md-12">
                <label>{{ $t('message.tel') }}</label>
                <input
                  :disabled="true"
                  :value="getPartnerContact(po.vendor.contacts).tel"
                  type="text"
                  class="form-control">
              </div>
            </div>
            <div class="form-group row mb-0">
              <div class="col-md-12">
                <label>{{ $t('message.email') }}</label>
                <input
                  :disabled="true"
                  :value="getPartnerContact(po.vendor.contacts).email"
                  type="text"
                  class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.reference') + ' & ' + $t('message.date')"/>
        <div class="form-row">
          <div class="col-md-6">
            <label>{{ $t('documents.po') }}</label>
            <select
              :disabled="true"
              class="form-control form-control-sm custom-select">
              <option>{{ po.po_code }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label>{{ $t('apps.inventory.message.receiptdate') }}</label>
            <BaseInputDatePicker
              v-model="form.scheduled_at"
            />
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="col-md-12 no-padding">
        <section-title :title="$t('apps.inventory.message.shipto')"/>
        <div class="form-row mb-2">
          <div class="col-md-12">
            <select
              v-model="form.warehouse_id"
              class="form-control form-control-sm custom-select">
              <option
                v-for="(item, index) in warehouses"
                v-if="item.is_deleted == false"
                :value="item.warehouse_id">
                {{ item.warehouse_name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-0">
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.orderlist')"/>
        <BaseNotFoundData
          v-if="!form.orders.length"
          :title="$t('message.notfoundorders')"
          class="mb-2"
        />
        <OrderGR
          v-if="isRenderOrders"
          :data="form.orders"
          :createAble="false"
          :showProductImage="true"
          :selectedWhId="form.warehouse_id"
          :addItemAble="true"
          :deleteItemAble="true"
          :changeSkuAble="true"
          :defaultItems="false"
          :optionBinLocations="optionBinLocations"
          class="custom-order-gr"
        />
        <div class="form-row mb-3">
          <div class="col-md-12">
            <textarea
              :placeholder="$t('placeholder.note')"
              v-model="form.note"
              class="form-control form-control-sm"
              style="min-height: 90px;"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <vs-checkbox
              v-model="form.received"
              color="#A3CA76"
              style="float: left;position: relative;top: 0;left: -5px;">
              {{ $t('apps.inventory.message.allitemswerereceived') }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    po: {
      type: Object,
    },
    validation: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      form: {
        scheduled_at: null,
        warehouse_id: null,
        note: '',
        received: false,
        orders: [],
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },
      isRenderOrders: true,
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      dateformat: 'getDateFormat',
      getMainWarehouse: 'getMainWarehouse',
      getWarehouseInfo: 'getWarehouseInfo',
      products: 'getProducts',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      getPartnerContact: 'getPartnerContact',
      isAssignedInWarehouse: 'isAssignedInWarehouse',
      isUseLot: 'isUseLot',
      isUseSerial: 'isUseSerial',
      getBinIdRecommended: 'getBinIdRecommended',
    }),
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    optionBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.warehouse_id) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
  },
  methods: {
    ...mapActions([
      'getNextGrCode',
      'clearNextGrCode',
    ]),
    isValid () {
      return true
    },
    validateform () {
      var isValid = false
      var data = null
      if (this.isValid()) {
        isValid = this.form.orders.length > 0
        data = {
          orders: this.form.orders,
          scheduled_at: this.form.scheduled_at ? this.form.scheduled_at : new Date(),
          warehouse_id: this.form.warehouse_id,
          note: this.form.note.trim().length > 0 ? this.form.note.trim() : null,
          received: this.form.received,
        }
      }
      this.$emit('submit', isValid, data)
    },
    getSku (sku_id) {
      let product = this.getProductInfoBySkuId(sku_id)
      return product.prices.find(sku => sku.sku_id == sku_id)
    },
    getToReceiptCount(skuId) {
      let result = 0
      const goodsreceipts = this.po.reference.goodsreceipts
      for (const goodsreceipt of goodsreceipts) {
        for (const order of goodsreceipt.orders) {
          if (order.sku_id === skuId) {
            result += order.quantity
          }
        }
      }
      return result
    },
    getRecommendedQty(orderQty, toReceiptCount) {
      const result = orderQty - toReceiptCount
      return result > 0
        ? result
        : 0
    },
    setFormOrders () {
      this.form.orders = []
      for (const order of this.po.orders) {
        const skuInfo = this.getSku(order.sku_id)
        const stock = skuInfo.stocks.find(stock => stock.warehouse_id == this.form.warehouse_id)
        if (stock) {
          const bin_location_id = this.getBinIdRecommended(stock.stock_locations)
          const pass = this.isAssignedInWarehouse(order.sku_id, this.form.warehouse_id)
          if (pass) {
            const useLot = this.isUseLot(order.sku_id)
            const useSeril = this.isUseSerial(order.sku_id)
            const toReceiptCount = this.getToReceiptCount(order.sku_id)
            const recommendedQty = this.getRecommendedQty(order.quantity, toReceiptCount)
            this.form.orders.push({
              sku_id: order.sku_id,
              item: order.item,
              description: order.description,
              quantity: recommendedQty,
              price: order.price,
              done: 0,
              selectize: {
                loading: false,
                updateOption: null,
                trickValidation: 0,
              },
              use_lot: useLot,
              use_serial: useSeril,
              lot: {
                binId: null,
                dateProduct: null,
                dateExpire: null,
                cost: order.price,
              },
              serials: (() => {
                const items = []
                for (let i = 0; i < order.quantity; i++) {
                  items.push({
                    binId: null,
                    serialNumber: null,
                    dateProduct: null,
                    dateExpire: null,
                    cost: order.price,
                  })
                }
                return items
              })(),
              bin_location_id: bin_location_id,
            })
          }
        }
      }
    },
  },
  watch: {
    validation () {
      this.validateform()
    },
    'form.warehouse_id': {
      handler: async function (after, before) {
        let warehouse_id = after
        let warehouseInfo = this.getWarehouseInfo(warehouse_id)

        if (before != null) {
          this.clearNextGrCode()
        }

        // get next gr code
        await this.getNextGrCode({
          warehouse_id: warehouseInfo.warehouse_id,
          short_name: warehouseInfo.short_name,
        })
        // finish bar loading
        this.showFinish(this.$Progress)

        this.isRenderOrders = false
        this.setFormOrders()
        setTimeout(() => this.isRenderOrders = true, 10)
      },
      deep: true,
    },
  },
  created: async function () {
    // set date format
    this.formats.input = [this.dateformat + ' HH:mm:ss']
    this.formats.dayPopover = this.dateformat + ' HH:mm:ss'
    this.form.scheduled_at = new Date()
    // set form
    this.form.warehouse_id = this.getMainWarehouse.warehouse_id
    // get products
    if (this.products.length == 0) {
      await this.getProducts()
    }
  },
}
</script>

<style scoped>
.custom-order-gr /deep/ img {
  width: 31px;
  height: 31px;
}

.custom-order-gr /deep/ .input-group .popover-container {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/FormGoodsReceipt.vue